/*
 * Copyright (c) 2023 Bolmate B.V.
 */

let navigationParam: any = null;

export const setNavigationParam = (param: any) => {
    navigationParam = param;
};

export const getNavigationParam = (): any => {
    return navigationParam;
};

export function clearNavigationParam() {
    navigationParam = null;
}
